import { render, staticRenderFns } from "./TherapistDashPostRegistrationModal.vue?vue&type=template&id=866d5c36&scoped=true"
import script from "./TherapistDashPostRegistrationModal.vue?vue&type=script&lang=js"
export * from "./TherapistDashPostRegistrationModal.vue?vue&type=script&lang=js"
import style0 from "./TherapistDashPostRegistrationModal.vue?vue&type=style&index=0&id=866d5c36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "866d5c36",
  null
  
)

export default component.exports